import React, { memo } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { a } from "../appColors";

export const PANEL_MAX_WIDTH = 771;

/**
 * The paper itself: one whole question at a time (Figma 193:56).
 *
 * Showing a single question and moving between them from the sidebar is what
 * keeps this from being one long scroll — a paper is otherwise metres of
 * page. The panel still scrolls, because one question with several parts can
 * be taller than the window, but its bar is hidden so the column keeps the
 * shape the design gives it. Hiding a scrollbar is only safe because there is
 * another way to reach everything: the list beside it.
 */
const PaperPanel = ({ number, children, contentRef, scrollRef, overlay }) => (
  <Flex
    direction="column"
    maxW={`${PANEL_MAX_WIDTH}px`}
    mx="auto"
    height="100%"
    minH={0}
    bg={a.panel}
    border="1px solid"
    borderColor={a.panelBorder}
    borderRadius="14px"
    overflow="hidden"
    // The column it sits in lets presses through to the page around it.
    pointerEvents="auto"
  >
    <Box
      ref={scrollRef}
      flex="1"
      minH={0}
      overflowY="auto"
      overflowX="hidden"
      sx={{
        scrollbarWidth: "none",
        msOverflowStyle: "none",
        "&::-webkit-scrollbar": { display: "none" },
        // The question moved to is the one to read, so a jump lands at its
        // top rather than wherever the last one left off.
        scrollBehavior: "smooth",
      }}
    >
      {/* Annotations belong to the paper, not to the window, so they live
          inside what scrolls. Drawing beside a part stays beside that part
          when the question moves.

          The padding sits inside this box rather than around it, so the
          layer reaches the panel's edges: with the padding outside, the
          margin round the question was the one place on the paper nothing
          could be drawn. */}
      <Box position="relative" minH="100%">
        <Box
          ref={contentRef}
          px={{ base: "18px", md: "33px" }}
          py={{ base: "18px", md: "30px" }}
        >
          {number != null && (
            <Text fontSize="11px" fontWeight="600" color={a.text} mb="14px">
              {number}.
            </Text>
          )}
          {children}
        </Box>
        {overlay}
      </Box>
    </Box>
  </Flex>
);

export default memo(PaperPanel);
